import { createAction, props } from '@ngrx/store';
import { EventModel } from 'src/app/models/event.model';
import { MonthModel } from 'src/app/models/month.model';
import { StateModel } from 'src/app/models/state.model';

export const EVENT_FEATURE = 'event';
export const SEARCH_EVENT = '[Event] Search Event';
export const FILTER_EVENTS_BY_STATE = '[Event] Filter Events By State';
export const FILTER_EVENTS_BY_MONTH = '[Event] Filter Events By Month';
export const SET_FILTERED_EVENTS = '[Event] Filtered Events';

export const searchEvent = createAction(SEARCH_EVENT, props<{ searchedEvent: string }>());
export const filterEventsByState = createAction(FILTER_EVENTS_BY_STATE, props<{ filteredState: StateModel | null }>());
export const setFilteredEvents = createAction(SET_FILTERED_EVENTS, props<{ filteredEvents: EventModel[] | null }>());
export const filterEventsByMonth = createAction(FILTER_EVENTS_BY_MONTH, props<{ filteredMonth: MonthModel | null }>());
